import { useState } from 'react'
import type { Project } from '../lib/api'

interface ProjectBarProps {
  projects: Project[]
  selectedId: number | null
  doneCount: number
  onSelect: (id: number) => void
  onCreate: (name: string) => void
  onDelete: (id: number) => void
}

export default function ProjectBar({
  projects,
  selectedId,
  doneCount,
  onSelect,
  onCreate,
  onDelete,
}: ProjectBarProps) {
  const [newName, setNewName] = useState('')

  const submit = () => {
    const name = newName.trim()
    if (!name) return
    onCreate(name)
    setNewName('')
  }

  return (
    <div className="flex flex-wrap items-center gap-3">
      <label className="text-sm font-medium text-text-soft">Projet</label>
      <select
        value={selectedId ?? ''}
        onChange={(e) => onSelect(Number(e.target.value))}
        className="bg-white border border-kanban-border rounded-lg px-3 py-2 text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-kanban-navy"
      >
        {projects.length === 0 && <option value="">Aucun projet</option>}
        {projects.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
      </select>

      <div className="flex items-center gap-2">
        <input
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
          placeholder="Nouveau projet…"
          className="bg-white border border-kanban-border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-kanban-navy w-48"
        />
        <button
          onClick={submit}
          className="px-3 py-2 rounded-lg bg-kanban-navy text-white text-sm font-medium hover:bg-kanban-navy-soft transition"
        >
          Créer
        </button>
      </div>

      {selectedId != null && (
        <button
          onClick={() => onDelete(selectedId)}
          className="px-3 py-2 rounded-lg border border-red-200 text-red-600 text-sm font-medium hover:bg-red-50 transition"
          title="Supprimer ce projet"
        >
          Supprimer
        </button>
      )}

      <div className="ml-auto flex items-center gap-2 bg-white border border-kanban-border rounded-lg px-4 py-2">
        <span className="text-sm text-text-soft">Done</span>
        <span className="inline-flex items-center justify-center min-w-[24px] h-6 px-1.5 rounded-full bg-status-done text-white text-xs font-bold">
          {doneCount}
        </span>
      </div>
    </div>
  )
}
